import React, { Component } from "react";
import { observer } from "mobx-react";
import { Web3Store } from "../stores/web3Store";
import { RouteComponentProps, withRouter } from "react-router-dom";
import banner from "../images/market-banner.png";
import { Button, Checkbox, Input, Popover, Space } from "antd";
import {
    IGetLicenseCollectionsResponse,
    ILicenseCollection,
    IMythServerResponse,
    IPagination,
    IPRsp
} from "../bean/ResponseBean"
import "swiper/swiper.less";
import NFTIPList from "../components/nftIPList";
import { MythPagination } from "../components/pagination";
import "../styles/copyrightMarket.less";
import "../styles/searchPage.less";
import { MythServerResultCode } from "../constant/CommonConstant";
import logger from "../logger";
import { IGetAllIPsRequest } from "../bean/RequestBean";
import { IOrderConfig, ORDER_CONFIG } from "../utils/orderUtils";
import { PageLoader } from "../components/pageLoader";
import { getRoutePath, MythRouteId } from "../router-config";

interface IProps {
    web3Store: Web3Store;
}

interface IStates {
    searchResult: IPRsp[],
    pageNum: number,
    totalPage: number,
    totalNum: number,
    keywords: string,
    priceSorting: string,
    timeSorting: string,
    onlyPFP: boolean,
    licenseCollections: ILicenseCollection[],
    orderConfig: IOrderConfig,
    loading: boolean
}

type ISearchProps = IProps & RouteComponentProps;

const KEY_IP_LIST_SESSION_STORAGE = "myth_ip_list";
@observer
class IPListPage extends Component<ISearchProps, IStates> {
    private pageSize = 40;
    private selectedIds: number[] = [];

    constructor(props: ISearchProps, state: IStates) {
        super(props);
        let locationState: any = this.props.location.state;
        if (locationState && locationState.selectedCollectionId) {
            this.selectedIds.push(locationState.selectedCollectionId)
        }
        this.state = {
            searchResult: [],
            pageNum: 1,
            keywords: !!locationState && locationState.keywords ? locationState.keywords : "",
            priceSorting: "",
            timeSorting: "",
            onlyPFP: false,
            totalNum: 0,
            totalPage: 0,
            licenseCollections: [],
            orderConfig: ORDER_CONFIG.default,
            loading: true,
        }
    }

    componentDidMount(): void {
        const item = sessionStorage.getItem(KEY_IP_LIST_SESSION_STORAGE);
        if (item) {
            const data = JSON.parse(item);
            if (data && data.searchResult && data.searchResult.length > 0) {
                this.setState(data);
                sessionStorage.removeItem(KEY_IP_LIST_SESSION_STORAGE);
                return;
            }
        }
        this.getAllIps().then(value => {
            this.getLicenseCollections();
        });
    }

    // componentWillUnmount(): void {
    //     let searchData = JSON.stringify(this.state);
    //     sessionStorage.setItem(KEY_IP_LIST_SESSION_STORAGE,searchData);
    // }
    //
    saveStateData = () => {
        let searchData = JSON.stringify(this.state);
        sessionStorage.setItem(KEY_IP_LIST_SESSION_STORAGE, searchData);
    };

    getAllIps = async () => {
        const { web3Store } = this.props;
        const { keywords, pageNum, onlyPFP, orderConfig } = this.state;
        try {
            if (web3Store.mythServerApi) {
                const requestParams: IGetAllIPsRequest = {
                    keywords: keywords,
                    licenseCollectionIds: this.selectedIds,
                    filterIPL: onlyPFP,
                    pageNum: pageNum,
                    pageSize: this.pageSize,
                    orderField: orderConfig.field,
                    orderDirection: orderConfig.direction
                };
                const result: IMythServerResponse<IPagination<IPRsp>> = await web3Store.mythServerApi.getAllIps(requestParams);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            searchResult: data.dataList,
                            pageNum: data.pageNum,
                            totalPage: data.totalPage,
                            totalNum: data.totalNum,
                            loading: false
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    getLicenseCollections = async () => {
        const { web3Store } = this.props;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<IGetLicenseCollectionsResponse> = await web3Store.mythServerApi.getLicenseCollections();
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            licenseCollections: data.licenseCollections
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    onChangePage = (pageNo: number) => {
        this.setState({ pageNum: pageNo, loading: true }, () => this.searchNFT());
    };

    onChangePFP = (e: any) => {
        this.setState({
            onlyPFP: e.target.checked,
            loading: true,
            pageNum: 1
        }, () => {
            this.searchNFT();
        })
    };

    searchSift = () => {
        this.setState({
            loading: true,
            keywords: "",
            pageNum: 1
        }, () => {
            this.searchNFT();
        })
    };

    onChangeSift = (val: any) => {
        this.selectedIds = val;
    };
    private orderI: number = 0;
    private iconClass: string[] = ["", "down-", "up-"];
    onChangePriceSorting = () => {
        const order = [ORDER_CONFIG.default, ORDER_CONFIG.priceDESC, ORDER_CONFIG.priceASC];
        this.orderI = (this.orderI + 1) % 3;
        this.setState({
            orderConfig: order[this.orderI],
            loading: true,
            pageNum: 1
        }, () => {
            this.searchNFT();
        })
    };

    popContent = () => {
        const { licenseCollections } = this.state;
        const CheckboxGroup = Checkbox.Group;
        return <div className="pop-sift">
            <CheckboxGroup onChange={this.onChangeSift} name="siftCheck" defaultValue={this.selectedIds}>
                {licenseCollections.map((item, i) => (
                    <Checkbox className="sift-item" value={item.id} key={item.id}>
                        <img src={item.logo} alt="" />{item.name}
                    </Checkbox>
                ))}
            </CheckboxGroup>
            <div className="text-center"><Button className="myth-button" onClick={this.searchSift}>search</Button></div>
        </div>
    };

    changeInput = (e: any) => {
        let value = e.target.value;
        this.setState({
            keywords: value
        })
    };

    searchNFT = () => {
        this.getAllIps();
    };

    onPressInputSearch = () => {
        this.selectedIds = [];
        this.setState({
            loading: true,
        }, () => {
            this.getAllIps();
        });
    };

    onClickLicenseNFT = (e: any) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.LicensePage),
        });
    };

    render() {
        const { searchResult, pageNum, keywords, totalNum, totalPage, loading } = this.state;

        return <div className="market-container search-page-container">
            <div className="market-banner text-center" style={{ backgroundImage: `url(${banner})` }}>
                <div className="market-title">Community-driven<br />
                    NFT <span className="dazzling-text">  Licensing  <span className="dazzling-text">  Licensing  </span></span>  market
                </div>
                <Input onPressEnter={this.onPressInputSearch} onChange={this.changeInput} value={keywords}
                    className="market-search" prefix={<i className="iconfont icon-search"></i>}
                    placeholder="Search by collection" />
                <div><Space size={40}>
                    <span className="authorize-link" onClick={this.onClickLicenseNFT}>License my NFT <i
                        className="iconfont icon-24gf-forward"></i></span>
                    <span className="authorize-link">License my work <i
                        className="iconfont icon-24gf-forward"></i></span>
                </Space></div>
            </div>

            <div className="market-section">
                <div className="flex-row space-between result-title-container">
                    <div>
                        <span className="list-title">All</span>
                        <span className="total-num">({totalNum})</span>
                    </div>
                    <div className="search-form">
                        {/* <span className="search-item">
                                    <Checkbox onChange={this.onChangePFP} checked={onlyPFP}>ONLY PFP-IPL</Checkbox>
                                </span> */}
                        <span className="search-item">
                            <Popover placement="left" content={this.popContent}>
                                Filter<i className="iconfont icon-shaixuan"></i>
                            </Popover>
                        </span>
                        <span className="search-item" onClick={this.onChangePriceSorting}>Price Sorting<i
                            className={`iconfont icon-sort-${this.iconClass[this.orderI]}full`}></i></span>
                    </div>
                </div>
                {
                    loading ? <PageLoader></PageLoader> :
                        <>
                            <NFTIPList list={searchResult} className="search-result-list" saveStateData={this.saveStateData} />
                            <MythPagination totalPage={totalPage} total={totalNum} showTotal={true}
                                currentPage={pageNum} pageSize={this.pageSize}
                                onChange={(pageNo: number) => this.onChangePage(pageNo)} />
                        </>
                }
            </div>
        </div>
    }
}

export default withRouter(IPListPage);
